export default function (selector, updated_selector) {
	if (updated_selector === undefined) {
		updated_selector = selector;
		}

		if ($(selector).length === 0) {
			return false;
		}

		var height = 0;
		$(selector).each(function(){
			height = Math.max( height, $(this).outerHeight() );
		});

		var maxHeight = $(updated_selector).css('max-height');
		maxHeight = maxHeight.slice(0, maxHeight.length-2);

		if (height > maxHeight ) {
			height = maxHeight;
		}
		
		$(updated_selector).outerHeight(height);
}


// WEBPACK FOOTER //
// ./scripts/util/equalHeights.js